var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.625C22 8.34629 22 7.70693 21.8594 7.18237C21.478 5.75887 20.3661 4.64698 18.9426 4.26556C18.4181 4.125 17.7787 4.125 16.5 4.125C15.2213 4.125 14.5819 4.125 14.0574 4.26556C12.6339 4.64698 11.522 5.75887 11.1406 7.18237C11 7.70693 11 8.34629 11 9.625M7.15 28.875H25.85C27.3901 28.875 28.1602 28.875 28.7485 28.5753C29.2659 28.3116 29.6866 27.8909 29.9503 27.3735C30.25 26.7852 30.25 26.0151 30.25 24.475V14.025C30.25 12.4849 30.25 11.7148 29.9503 11.1265C29.6866 10.6091 29.2659 10.1884 28.7485 9.92473C28.1602 9.625 27.3901 9.625 25.85 9.625H7.15C5.60986 9.625 4.83978 9.625 4.25153 9.92473C3.73408 10.1884 3.31338 10.6091 3.04973 11.1265C2.75 11.7148 2.75 12.4849 2.75 14.025V24.475C2.75 26.0151 2.75 26.7852 3.04973 27.3735C3.31338 27.8909 3.73408 28.3116 4.25153 28.5753C4.83978 28.875 5.60986 28.875 7.15 28.875Z",
    stroke: "#61646C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase01);
export default __webpack_public_path__ + "static/media/briefcase-01.1856b6f677f30136d12b1313349b15a0.svg";
export { ForwardRef as ReactComponent };